import { render } from "./CustomSelectValLabel.vue?vue&type=template&id=12c4c6fe&scoped=true"
import script from "./CustomSelectValLabel.vue?vue&type=script&lang=js"
export * from "./CustomSelectValLabel.vue?vue&type=script&lang=js"

import "./CustomSelectValLabel.vue?vue&type=style&index=0&id=12c4c6fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12c4c6fe"

export default script